import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-brand-details',
  templateUrl: './brand-details.component.html',
  styleUrls: ['./brand-details.component.scss'],
})
export class BrandDetailsComponent implements OnInit {

  @Input() organizationId: any;
  @Input() editOrganizationId: any;
  @Input() storedFormData: any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitOrganizationData: EventEmitter<void> = new EventEmitter<void>();

  brandDetailsForm!: FormGroup;

  @Input() isUserEditing: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _modalService: ModalsService
  ) { }

  ngOnInit() {
    this.brandDetailsForm = this._fb.group({
      imagePath: [null],
      imageFile: [null],
      primaryColor: [null],
      secondaryColor: [null],
      enquiryNumber1: [null],
      enquiryNumber2: [null],
      facebookLink: [''],
      instagramLink: [''],
      review1: [''],
      review2: [''],
      rating: [''],
      showManualReviews: [false],
      showReviewsInTemplate: [true]
    });

    this.brandDetailsForm.valueChanges.subscribe(() => {
      this.brandDetailsForm.markAsTouched();
    })

    if (this.storedFormData) {
      this.patchBrandDetails(this.storedFormData);
    }
  }

  patchBrandDetails(formData: any) {
    this.brandDetailsForm.patchValue({
      ...formData,
      imagePath: formData.imagePath,
      imageFile: formData.imagePath,
    });
  }

  // Uploading organization LOGO
  onOrganizationLogoSelected(event: any) {
    const file = event.target.files[0];
    // Checking if image is more than 5MB
    if (file.size > 5 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
      return;
    }
    if (file) {
      this.brandDetailsForm.get('imageFile')?.setValue(file);
      this.brandDetailsForm.markAsDirty();
    }
  }

  deleteOrganizationImage() {
    this.brandDetailsForm.get('imagePath')?.setValue(null);
    this.brandDetailsForm.get('imageFile')?.setValue(null);
    this.brandDetailsForm.markAsDirty();
  }

  openAttachment(file: any) {
    this._modalService.openImageModal(this.getDocumentUrl(file));
  }

  getDocumentUrl(file: any) {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      return fileURL;
    } else {
      return file;
    }
  }

  async onSubmit(): Promise<boolean> {
    if (this.brandDetailsForm.valid) {
      try {
        const formData = this.brandDetailsForm.value;  
        this.brandDetailsForm.markAsPristine();
        this.storeFormData.emit(formData);
        this.submitOrganizationData.emit();
        return true;
      } catch (error) {
        console.error("Error while adding visa info", error);
        this._responseNotificationService.showMessage("Failed to add Visa Information", true);
        return false;
      }
    } else {
      this.brandDetailsForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.brandDetailsForm.dirty || this.brandDetailsForm.invalid) && this.brandDetailsForm.touched;
  }

}
